
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { FabricantesFabricantes } from "@/types/reports/fabricantes/fabricantesFabricantes/FabricantesFabricantes";
import { FabricanteFilter } from "@/types/fabricantes/FabricanteView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<FabricantesFabricantes> = ref({
      totalFabricantes: "",
      fabricantes: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("fabricanteFilter");
      let filter = {} as FabricanteFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportFabricantesFabricantesDB(filter);
      report.value = response;
      //console.log(report);
      isLoading.value = false;
    }

    async function getExcel() {
      const filterString = localStorage.getItem("fabricanteFilter");
      let filter = {} as FabricanteFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      apiExcel.getReportFabricantesFabricantesDB(filter);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
